import React from "react";
import RegularButton from "components/CustomButtons/Button";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import EditIcon from "@material-ui/icons/Edit";
import { useToggle } from "hooks/useToggle";
import { blue } from "@material-ui/core/colors";
import { ModalV2 } from "components/Modal/ModalV2";
import { FormTags } from "./FormTags";

export const mainTagsColumns = [
  {
    Header: "Numero",
    accessor: "number",
    filterable: true,
    filterMethod: (filter, row) =>
      row.number.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Acceso",
    accessor: "access",
    filterable: true,
    filterMethod: (filter, row) =>
      row.access.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Numero de empleado",
    accessor: "employeeNumber",
    filterable: true,
    filterMethod: (filter, row) =>
      row.employeeNumber
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Planta",
    accessor: "station",
    filterable: true,
    filterMethod: (filter, row) =>
      row.station
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "",
    accessor: "id",
    sortable: false,

    filterable: false,
    Cell: ({original}) => {
      // const hist = useHistory()
      const [open, setOpen] = useToggle()
      return (
        <>
          <RegularButton
            justIcon
            round
            onClick={setOpen}
            color="transparent"
            >
            <EditIcon style={{color: blue[500]}}/>
          </RegularButton>
          <ModalV2
            open={open}
            onClose={setOpen}
            title="Editar tag"
            // toRight
          >
            <FormTags isEdit tag={original} onClose={setOpen}/>
          </ModalV2>
            </>
      )
    },
  }
];

